import { Box, Flex, Text } from '@chakra-ui/react'
import { FaCircleExclamation } from 'react-icons/fa6'
import { ButtonCmp } from '../../../../../../../components/ButtonCmp'
import { iEntradaHistorico } from '../..'

import { formatarDataHora } from '../../../../../utils/data'

interface iProps {
  entradas: iEntradaHistorico[]
  onAbrir: (entrada: iEntradaHistorico) => void
}

export const HistoricoAjustes: React.FC<iProps> = ({ entradas, onAbrir }) => {
  return (
    <Box bgColor={'var(--Gray6)'} borderTop={'1px solid var(--Gray5)'} p={'1rem'}>
      <Text fontSize={'11px'} fontWeight={'600'} color={'var(--Gray3)'} textTransform={'uppercase'} letterSpacing={'.05em'} mb={'.75rem'}>
        Solicitações anteriores
      </Text>

      <Flex flexDir={'column'} gap={'.75rem'}>
        {entradas.map((entrada, i) => {
          const { solicitacao, quantidade } = entrada
          const data = formatarDataHora(solicitacao.dataSolicitacao)

          return (
            <Flex key={solicitacao.solicitacaoId ?? i} gap={'.75rem'} position={'relative'}>
              {i !== entradas.length - 1 && (
                <Box position={'absolute'} left={'7px'} top={'1.25rem'} bottom={'-.75rem'} w={'2px'} bgColor={'var(--Gray5)'} />
              )}

              <Box mt={'.375rem'} zIndex={1}>
                <Box w={'16px'} h={'16px'} borderRadius={'50%'} bgColor={'var(--Orange)'} border={'2px solid white'} />
              </Box>

              <Flex
                flex={'1'}
                bgColor={'white'}
                border={'1px solid var(--Gray5)'}
                borderRadius={'.25rem'}
                py={'.625rem'}
                px={'.875rem'}
                justifyContent={'space-between'}
                alignItems={'center'}
                gap={'.75rem'}
                flexWrap={'wrap'}
              >
                <Box>
                  <Flex alignItems={'center'} gap={'.5rem'} flexWrap={'wrap'}>
                    <Text fontSize={'14px'} fontWeight={'500'} color={'var(--Gray1)'}>Solicitação de ajuste</Text>
                    {data && <Text fontSize={'12px'} color={'var(--Gray3)'}>· {data}</Text>}
                  </Flex>
                  <Flex alignItems={'center'} gap={'.375rem'} mt={'.125rem'} color={'var(--Gray3)'}>
                    <FaCircleExclamation size={11} color={'var(--Orange)'} />
                    <Text fontSize={'12px'}>
                      {quantidade === 1 ? '1 item solicitado' : `${quantidade} itens solicitados`}
                    </Text>
                  </Flex>
                </Box>

                <ButtonCmp small OutlineColor={'OrangeEscuro'} onClick={() => onAbrir(entrada)}>
                  Ver solicitações
                </ButtonCmp>
              </Flex>
            </Flex>
          )
        })}
      </Flex>
    </Box>
  )
}
